// extracted by mini-css-extract-plugin
module.exports = {"layout":"KLayout_layout__pBU6o"};